import { getConsignableSales, getSales } from "./root";

export const getConsignableSaleById = livestockSaleId => state =>
  getConsignableSales(state)[livestockSaleId] || null;

export const getSaleById = saleId => state => getSales(state)[saleId] || null;
